import {createAction} from '@reduxjs/toolkit'
import {
  BI_ORIGINS,
  EventsDates,
  PAST_EVENT_STATUSES,
  UPCOMING_EVENT_STATUSES,
  getEventId,
} from '@wix/wix-events-commons-statics'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {EventsList, Tabs} from '../../../../commons/enums'
import {getLocale} from '../../../../commons/selectors/environment'
import {getEventUrl} from '../../../../commons/selectors/event'
import {openModal, openModalOld} from '../../../../commons/services/modal'
import {isTicketedWithNoOrder} from '../selectors/event'
import {getMemberId, isOwnProfile} from '../selectors/user'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent, GetState, StoreExtraArgs} from '../types/state'
import {getMyTickets, getMyTicketsOld} from './tickets'

export const TOGGLE_EVENT_DETAILS_OLD = 'TOGGLE_EVENT_DETAILS_OLD'

interface GetEventsResponse {
  events: wix.events.Event[]
  orders: wix.events.ticketing.Order[]
  rsvps: wix.events.rsvp.Rsvp[]
  total: number
  dates: {events: EventsDates}
}

export const getEvents = createAsyncAction<GetEventsResponse, {tab: Tabs}>(
  'GET_EVENTS',
  async ({tab}, {getState, extra: {serverApi}}) => {
    const state = getState()
    const isUpcoming = tab === Tabs.UPCOMING
    const statuses = isUpcoming ? UPCOMING_EVENT_STATUSES : PAST_EVENT_STATUSES
    const offset = state.events[isUpcoming ? EventsList.UPCOMING : EventsList.PAST].length
    const memberId = getMemberId(state)
    const locale = getLocale(state)

    return serverApi.getEvents({
      memberId,
      statuses,
      extended: isOwnProfile(state),
      offset,
      locale,
    })
  },
)

export const toggleEventDetailsOld = (event: DetailedEvent) => async (dispatch: Function, getState: GetState) => {
  const eventId = getEventId(event.event)
  const state = getState()

  if (state.user.currentUserId === state.user.viewedSiteMemberId && isTicketedWithNoOrder(event)) {
    dispatch(getMyTicketsOld(eventId))
  }

  dispatch({
    type: TOGGLE_EVENT_DETAILS_OLD,
    payload: eventId,
  })
}

export const toggleEventDetails = createAsyncAction<void, {event: DetailedEvent}>(
  'TOGGLE_EVENT_DETAILS',
  async ({event}, {getState, dispatch}) => {
    const eventId = getEventId(event.event)
    const state = getState()

    if (state.user.currentUserId === state.user.viewedSiteMemberId && isTicketedWithNoOrder(event)) {
      dispatch(getMyTickets({eventId}))
    }
  },
)

export const closeAllEvents = createAction('CLOSE_ALL_EVENTS')

export const setTab = createAction<Tabs>('SET_TAB')

interface ShareEventArgs {
  event: DetailedEvent
  returnFocusElement?: string
}

export const shareEventOld =
  ({event: {event}, returnFocusElement}: ShareEventArgs) =>
  async (dispatch: Function, getState: GetState, {pageUrl}: StoreExtraArgs) => {
    const eventId = event.id
    const eventUrl = getEventUrl(pageUrl, event, getState().multilingual)

    dispatch(shareEventClicked())
    await dispatch(
      openModalOld({
        type: 'share-event',
        params: {eventUrl, eventId, origin: BI_ORIGINS.MEMBERS_AREA},
      }),
    )
    dispatch(setActiveElement(returnFocusElement))
  }

export const shareEvent = createAsyncAction<void, ShareEventArgs>(
  'SHARE_EVENT',
  async ({event: {event}, returnFocusElement}, {getState, dispatch, extra: {pageUrl}}) => {
    const eventId = event.id
    const eventUrl = getEventUrl(pageUrl, event, getState().multilingual)

    dispatch(shareEventClicked())
    await dispatch(
      openModal({
        type: 'share-event',
        params: {eventUrl, eventId, origin: BI_ORIGINS.MEMBERS_AREA},
      }),
    )
    dispatch(setActiveElement(returnFocusElement))
  },
)

export const seeOtherEvents = createAction('SEE_OTHER_EVENTS')

export const shareEventClicked = createAction('SHARE_EVENT_CLICKED')
